module.exports = __webpack_public_path__ + "static/img/Logo_SL360_new.7fa562f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Logo_SL360_new.png
// module id = /dvw
// module chunks = 1